<template>
  <div id="modal">
    <mu-dialog
      :open="true"
      scrollable
      title="新建档案"
      dialogClass="dialog-horizon"
      bodyClass='dialogBody'
    >
      <div class="create-info" style="display: flex;flex-direction: column;">
        <mu-text-field
          label      = "姓名"
          :errorText = "fieldErrorMessages.name"
          @input = 'validateFormModels'
          name       = "姓名"
          :maxLength = "20"
          v-model    = "name"
        />
        <br/>
        <div class="birthday">
        <mu-text-field class="c-year" v-model="c_year" label="出生日期" /><span>年</span><mu-text-field v-model="c_month" class="c-month" /><span>月</span><mu-text-field v-model="c_day" class="c-day"/><span>日</span>
        </div>
        <span class="is-danger" v-if="showError">
          {{errorContent}}
        </span>
        <br/>
        <!-- <mu-date-picker
          mode        = "landscape"
          :label      = "dateName"
          :errorText = "fieldErrorMessages.birthday"
          @input = 'validateFormModels'
          name        = "出生日期"
          v-model     = "birthday"
          style       = "transform: translate(3px, 0px);"
          :defaults   = "birthday"
          @changeDate = "getBirthday"
        />
        <span
          class="is-danger"
          style="margin-left:150px;"
        >
          {{ $parent.errorDate}}
        </span> -->

        <checkBlock
          :value     = "2"
          :label     = "select.gender.name"
          :options   = "select.gender.options"
          :flag      = "select.gender.flag"
          @changeVal = "getChange"
        >
        </checkBlock>

        <mu-text-field
          label      = "手机号"
          :errorText = "fieldErrorMessages.tele"
          @input = 'validateFormModels'
          :maxLength = "11"
          name       = "手机号"
          v-model    = "tele"
        />

        <mu-select-field
          :label="select.edus.name"
          :errorText = "fieldErrorMessages.edu"
          @input = 'validateFormModels'
          @change = 'validateFormModels'
          hintText="请选择"
          name="教育程度"
          v-model="edu"
        >
          <mu-menu-item
            v-for="(item, index) in select.edus.options"
            @click="getChange(item.id,select.edus.flag)"
            :key="index"
            :title="item.text"
            :value="item.id"
          />
        </mu-select-field>
      </div>
      <mu-raised-button
        label="确定"
        @click="submitData"
        class="btn-style"
        slot="actions"
        :disabled = 'allowSubmit === false'
        primary
      />
      <mu-raised-button
        label="取消"
        @click="cancelData"
        style="color:#999;margin-left:20px;"
        slot="actions"
      />
    </mu-dialog>
  </div>
</template>
<script>
  import Vue from 'vue'
  import checkBlock from '../../common/checkBlock.vue'
  import datePickerEl from '../../common/datePickerEl'
  import {curDate, getOtherDate, getSelect, formatDate} from '../../../assets/js/common.js'
  import {mapState} from 'vuex'

  export default ({
    data() {
      return {
        select: GLOBAL.selectOption,
        birthWidth: '288px',
        name: '',
        birthday: '',
        dateName: '出生日期',
        tele: '',
        gender: '2',
        edu: '',
        hand: '',
        hasTrailOrder:true,//是否可以创建院内试用订单
        fieldErrorMessages: {
          name: '',
          birthday: '',
          tele: '',
          edu: '',
        },
        allowSubmit: false,
        errorContent:"出生日期格式有误或大于今日",
        c_year:"",
        c_month:"",
        c_day:"",
        showError:false,
        trail_time:"", //院内使用订单的天数
      }
    },
    mounted(){
      this.getAvailable(this.org);
    },
    components:{
      checkBlock,
      datePickerEl
    },
    computed:{
      errorText(){
        return this.edu ? '' : '这是必选项'
      },
      phoneError: function(){
        if(this.$parent.errorMobile){
          return this.$parent.errorMobile
        }
        return this.errors.first('手机号');
      },
      ...mapState(["org"])
    },
    watch:{
      /* birthday(a,b){
        if(a != b) {
          this.$parent.errorDate = '';
        }
      }, */
      tele(a,b){
        if(a != b) {
          this.$parent.errorMobile = '';
        }
      }
    },
    methods: {
      validateFormModels: function()
      {
        let ret = true;
        for (let fieldKey in this.fieldErrorMessages)
        {
          this.fieldErrorMessages[fieldKey] = '';
        }
        //TODO validate name
        if (0 === this.name.trim())
        {
          this.fieldErrorMessages.name = '请输入姓名';
          ret = false;
        }
        else if (false == /^[\u4E00-\u9FA5\uF900-\uFA2D\w]+$/.test(this.name.trim()))
        {
          this.fieldErrorMessages.name = '请输入正确姓名';
          ret = false;
        }
        else if (this.name.trim().length > 20)
        {
          this.fieldErrorMessages.name = '姓名最长20个字符';
          ret = false;
        }
        //TODO validate birthday
        /* if (0 === this.birthday.length)
        {
          this.fieldErrorMessages.birthday = '请输入生日';
          ret = false;
        } */
        //TODO validate tele
        // if (0 === this.tele.length)
        // {
        //   this.fieldErrorMessages.tele = '请输入手机号';
        //   ret = false;
        // }
        if(this.tele.length>0){
            if (false === /^1\d{10}$/.test(this.tele))
          {
            this.fieldErrorMessages.tele = '手机号格式错误';
            ret = false;
          }
        }

        // if ('' === this.edu)
        // {
        //   this.fieldErrorMessages.edu = '请选择教育程度';
        //   ret = false;
        // }
        console.log(`allowSubmit = ${ret}`);
        this.allowSubmit = ret;
        return ret;
      },
      getAvailable(orgId){
        //判断是否可以使用院内试用订单
        this.$http.get(GLOBAL.ORDER + "goods/" + orgId + "/available",
        {emulateJSON: false})
        .then((res)=>{
          for(var item in res.data){
            if(res.data[item].code == "YN"){
              if(!res.data[item].disabled){
                this.trail_time = res.data[item].detail.min_num;
                this.hasTrailOrder = true;
              }else{
                this.hasTrailOrder = false;
              }
            }
          }
        })
      },
      fromatNum(num){
        return num.trim();
      },
      check_birthday(){
        var check_year = /\d{4}/; //年匹配4位数
        var check_month = /\d{2}/; //月匹配2位数
        var check_day = /\d{2}/; //日匹配2位数
        this.c_year = this.fromatNum(this.c_year);
        this.c_month = this.fromatNum(this.c_month);
        this.c_day = this.fromatNum(this.c_day);
        if(this.c_month < 10 && this.c_month.length == 1){
          this.c_month = `0${this.c_month}`;
        }
        if(this.c_day < 10 && this.c_day.length == 1){
          this.c_day = `0${this.c_day}`;
        }
        if(
          check_year.test(this.c_year) &&
          check_month.test(this.c_month) &&
          parseInt(this.c_month) < 13 &&
          parseInt(this.c_month) > 0 &&
          check_day.test(this.c_day) &&
          parseInt(this.c_day) < 32 &&
          parseInt(this.c_day) > 0
        ){
          this.showError = false;
          this.birthday = `${this.c_year}-${this.c_month}-${this.c_day}`;
          /* 比较填写的出生日期是否大于当天 */
          var birth_day = new Date();
          birth_day.setFullYear(this.c_year,this.c_month-1,this.c_day);
          var today = new Date();
          if(birth_day < today){
            return true;
          }else{
            this.showError = true;
            return false;
          }
          console.log(this.birthday);
        }else{
          this.showError = true;
          return false;
        }
      },
      submitData: function(){
        var self = this;
        if(this.tele.length == 0){
          this.fieldErrorMessages.tele = '手机号不能为空';
          return;
        }
        if(this.edu.length == 0){
          this.fieldErrorMessages.edu = '教育程度不能为空';
          return;
        }
        if(this.check_birthday()){
          self.submitCase(self.name, self.gender, self.birthday, self.tele, self.edu, self.hand,self.hasTrailOrder);
        }else{
          return;
        }
      },
      submitCase: function(name,gender,birthday,tele,edu,hand,hasTrailOrder) {
        var self = this;
        self.$http.post('/api/Cases/create', {
          'name': name,
          'gender': gender,
          'birthday': birthday,
          'telephone': tele,
          'education': edu,
          'hand': hand
        },{emulateJSON: true})
          .then(
            function(res){
              // console.log(res.headers.map.date[0])
              // console.log("Wed, 20 Dec 2017 05:44:07 GMT")
              if(res.body.resultCode == 30000){
                if(res.body.resultMsg.indexOf('手机') >= 0){
                  self.errorMobile = res.body.resultMsg;
                  self.fieldErrorMessages.tele = res.body.resultMsg;
                } else {
                  self.errorDate = res.body.resultMsg;
                }
              } else {
                /* 变量初始化，以免影响下一次新建档案的显示 */
                /* var data = new Date(Date.parse(res.headers.get("Date"))); */
                console.log(res.body);
                var data = res.body.today.split(" ")[0];
                console.log(data);
                self.showModal=false;
                self.name = '';
                self.age = '';
                self.$emit("refreshCreate");
                //如果机构可以创建院内试用订单
                if(hasTrailOrder){
                  // 新建患者时，同时新建一个院内试用订单（一个月）
                  self.createTrialOrder(res.body.aid,name,tele,data);
                }else{
                  return
                }
              }
            }
          )
      },
      createTrialOrder: function(id,name,tele,data){
        var acc = require('../../../app/store.js');
        this.$http.post(GLOBAL.ORDER+'trial-create',{
          'user_id': id,
          'user_name': name,
          'order_use_start_time': data,
          'order_use_end_time': getOtherDate(data,(this.trail_time?this.trail_time:30)),
          'user_mobile':tele,
          'remark': 'remark',
          'order_mode': 1,        // 订单生成方式，0、管理端，1、医生端，2、患者端
          'doc_id': acc.account.account_uuid,      // 医生id(说明 不可以为空)，类型字符串
          'doc_name': acc.account.name,  // 医生姓名(说明 不可以为空)，类型字符串
          'dept_id': acc.account.dept_id,    // 下单人科室(说明 可以为空)，类型字符串
          'dept_name': acc.account.dept_name,// 下单人科室名称(说明 可以为空)，类型字符串
          'org_id': acc.account.org_uuid,      // 机构id(说明 可以为空)，类型字符串
          'org_name': acc.account.orgName,  // 机构名称患者姓名(说明 可以为空)，类型字符串
        },
        {emulateJSON: false})
      },
      cancelData: function(){
        this.$parent.error = '';
        this.$emit('close');
      },
      getChange: function(option,flag){
        switch (flag) {
          case 'edus':
            this.edu = option;
            break;
          case 'hands':
            this.hand = option;
            break;
          case 'gender':
            this.gender = option;
            break;
          default:
            break;
        }
      },
      // 获取选择的生日
      getBirthday: function(item){
        this.birthday = item;
      }
    }
  })
</script>
<style>
  .dialog-horizon{
    position: relative !important;
  }
  .mu-date-display-year{
    height:30px!important;
    line-height: 30px!important;
  }
  .mu-date-display-year-title{
    font-size:30px!important;
    text-decoration: underline;
  }
  .mu-date-display-monthday-title{
    font-size: 16px
  }
  .c-year,.c-month,.c-day{
    width:65px !important;
    margin-right: 10px !important;
  }
  .c-month,.c-day{
    margin-left: 10px;
  }
  .c-year .mu-text-field-input,.c-month .mu-text-field-input,.c-day .mu-text-field-input{
    text-align: center;
  }
  .create-info .is-danger{
    color: #f44336;
    font-size: 12px;
    line-height: 12px;
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// caseModal.vue?348a08a3